import { FunctionComponent } from 'react'
import styles from './selectDaycareMobileDialog.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DaycareSelector from '@/components/DaycareSelector/daycareSelector'

interface SelectDaycareMobileDialogProps {
    open: boolean
    handleClose: () => void
    isParent: boolean
}

const SelectDaycareMobileDialog: FunctionComponent<SelectDaycareMobileDialogProps> = ({
    open,
    handleClose,
    isParent
}) => {
    const { t } = useTranslation()

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('myDaycares')} parent={isParent} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.Container}>
                    <DaycareSelector removeBackground />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} parent={isParent} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default SelectDaycareMobileDialog
